import React from 'react';
import styles from '../AccessBackOfficePermission.css';

class Row extends React.Component {
  render() {
    const { permission, checked, isSinglePermissionRow } = this.props;
    return (
      <div
        className={`${
          isSinglePermissionRow
            ? styles['access-backoffice-permission-single-submenu']
            : styles['access-backoffice-permission']
        }`}
      >
        <div className={'checkbox checkbox-primary'}>
          <input
            type="checkbox"
            id={permission.id}
            onChange={this._onChangeCheckbox}
            checked={checked}
          />
          <label for={permission.id}>{permission.sub_menu_name}</label>
        </div>
      </div>
    );
  }

  _onChangeCheckbox = () => {
    const { disabled } = this.props;
    if (!disabled) {
      this.props.onChangeCheckbox(this.props.permission);
    }
  };
}

export default Row;
